// extracted by mini-css-extract-plugin
export default {"container":"BlockedPage_container__oOIUY","message":"BlockedPage_message__YrRXG"};